import { render, staticRenderFns } from "./CommunityArticle.vue?vue&type=template&id=496ce16a&scoped=true"
import script from "./CommunityArticle.vue?vue&type=script&lang=ts"
export * from "./CommunityArticle.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CommunityArticle.vue?vue&type=style&index=0&id=496ce16a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "496ce16a",
  "18a32757"
  
)

export default component.exports